'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgLang(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M5.553 13.786c.356 0 .63-.165 1.074-.548l1.815-1.609h2.916c1.684 0 2.642-.979 2.642-2.642V4.859c0-1.67-.958-2.649-2.642-2.649H4.649C2.965 2.21 2 3.189 2 4.86v4.127c0 1.663 1.006 2.642 2.58 2.642h.151v1.24c0 .567.308.917.822.917zm.321-1.458v-1.493c0-.37-.164-.506-.506-.506h-.664c-.965 0-1.397-.466-1.397-1.404V4.914c0-.938.432-1.397 1.397-1.397h6.592c.965 0 1.403.46 1.403 1.397v4.011c0 .938-.438 1.404-1.403 1.404h-2.95c-.37 0-.548.061-.808.328l-1.664 1.67zM8.01 7.892c.343 0 .541-.192.555-.548l.089-2.389c.007-.363-.267-.623-.65-.623-.39 0-.658.253-.644.623l.082 2.39c.014.355.212.547.568.547zm0 1.841c.39 0 .705-.267.705-.65 0-.377-.315-.644-.705-.644-.397 0-.705.267-.705.644 0 .376.315.65.705.65z", fill: "currentColor", fillRule: "evenodd" })));
}

module.exports = SvgLang;
//# sourceMappingURL=Lang.js.map
